const prefix = 'comment';

export const createComment = `${prefix}`;

export const deleteComment = (commentId: number | string) => `${prefix}/${commentId}`;

export const editComment = (commentId: number | string) => `${prefix}/${commentId}`;
